import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=d2ea3c00"
var script = {}
import style0 from "./Template.vue?vue&type=style&index=0&id=d2ea3c00&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2ea3c00')) {
      api.createRecord('d2ea3c00', component.options)
    } else {
      api.reload('d2ea3c00', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=d2ea3c00", function () {
      api.rerender('d2ea3c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/Research/Template.vue"
export default component.exports